// Stato e riepilogo delle richieste documentali, comuni ad azienda e studio.
export const currentFiles = (files) =>
  files.filter((file) => !files.some((next) => next.replaces_id === file.id));

export function requestStatus(request, current) {
  if (request.status === "cancelled") return "Annullata";
  if (request.status === "completed") return "Completata";
  if (!current.length) return "Da caricare";
  if (current.some((file) => file.review_status === "rejected"))
    return "Da ricaricare";
  if (current.every((file) => file.review_status === "accepted"))
    return "Accettato";
  return "In verifica";
}

export function requestSummary(requests, files) {
  const active = requests.filter((request) => request.status !== "cancelled");
  const accepted = active.filter((request) =>
    ["Completata", "Accettato"].includes(
      requestStatus(
        request,
        currentFiles(files.filter((file) => file.request_id === request.id)),
      ),
    ),
  );
  return { accepted: accepted.length, total: active.length };
}
